import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=363c52d4&scoped=true&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.less?vue&type=style&index=0&id=363c52d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c52d4",
  null
  
)

export default component.exports